import React, { useState } from "react";
import "./TranxnCard.css";
import { Button } from "components/Buttons";
import ShowToast from "components/ShowToast";
import { moneyTransferAction } from "service/Auth.services";
import { MONEY_TRANSFER_ACTION, MONEY_TRANSFER_ACTION_AIRTEL } from "constants/app";

const TransectionCardAirtel = ({
  banksList,
  bankData,
  phone,
  userId,
  beneId,
  location, 
  beneName,
  ifsc,
  account,cusName,
  onSuccess
  
}) => {
  const [selectedBank, setSelectedBank] = useState(
    () => banksList?.at(0) || ""
  );
  const [transferType, setTransferType] = useState("IMPS");

  const [formData, setFormData] = useState({
    phone: "",
    accountNumber:account,
    ifscCode: ifsc,
    beneficiaryName: beneName,
    amount: "",
    mpin: "2242",
    cusName:cusName,
    otp:""
  });
  const [refId, setrefId] =useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [tempData, setTempdata] = useState('')
  const [otp, setOtp] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleBankChange = (e) => {
    setSelectedBank(e.target.value);
  };

  const handleTransferTypeChange = (e) => {
    setTransferType(e.target.value);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      const _formData = new FormData();
      _formData.set("BENEID", beneId);
      _formData.set("IFSCCode", formData.ifscCode);
      _formData.set("amount", formData.amount);
      _formData.set("MobileNo", phone);
      _formData.set("AccountNo", formData.accountNumber);
      _formData.set("userid", userId);
      _formData.set("mpin", formData.mpin);

      _formData.set("dmt", "dmt1");
      _formData.set("action", "SendOTPTransaction");
      const res = await moneyTransferAction(_formData, MONEY_TRANSFER_ACTION_AIRTEL.SEARCH_CUSTOMER);

      if (!res || !res.status) {
        ShowToast(res.message||"No Data Found", res?.message || "danger");
      } else if (res?.status) {
        setShowOtpModal(true);
        // setrefId(res.ref_id);
        setTempdata(res.ddata);
        ShowToast(res.message||"Details found", res?.message || "success");
      }
      return res;
    } catch (error) {
      ShowToast("Something went wrong", "danger");
    } finally {
      setLoading(false);
    }
  };
  const handleOtpSubmit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      const _formData = new FormData();
      _formData.set("beneid", beneId);
      _formData.set("phone", phone);
      _formData.set("token", tempData);
      _formData.set("account", formData.accountNumber);
       _formData.set("amount", formData.amount);
        _formData.set("beneName", formData.beneficiaryName);
         _formData.set("IFSCCODE", formData.ifscCode);
          _formData.set("CusName", formData.cusName);


      _formData.set("otp", otp);
      _formData.set("userid", userId);
       _formData.set("action", "TransferMoney");
        _formData.set("dmt", "dmt1");
      const res = await moneyTransferAction(_formData, MONEY_TRANSFER_ACTION_AIRTEL.SEARCH_CUSTOMER);

      if (!res || !res.status) {
        setShowOtpModal(true);
        onSuccess(res.ref_no);
        ShowToast(res.message||"No Data Found", res?.message || "danger");
      } else if (res?.status) {
        setShowOtpModal(false);
         onSuccess(res.ref_no);
        setrefId(res.ref_no);
        ShowToast(res.message||"Details found", res?.message || "success");
      }
      return res;
    } catch (error) {
      ShowToast("Something went wrong", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5>Transfer Money</h5>
      </div>

      <div className="overflowY card-body">
        <form onSubmit={handleSubmit} className="app-form">

          {/* Beneficiary Name */}
          <div className="floating-form mb-3">
            <input
              type="text"
              name="beneficiaryName"
              className="form-control"
              placeholder="Enter Beneficiary Name"
              value={formData.beneficiaryName}
              onChange={handleChange}
              disabled={loading}
            />
            <label className="form-label">Beneficiary Name</label>
          </div>

          {/* Account Number */}
          <div className="floating-form mb-3">
            <input
              type="number"
              name="accountNumber"
              className="form-control"
              placeholder="Enter Account Number"
              value={formData.accountNumber}
              onChange={handleChange}
              disabled={loading}
            />
            <label className="form-label">Account Number</label>
          </div>

          {/* IFSC Code */}
          <div className="floating-form mb-3">
            <input
              type="text"
              name="ifscCode"
              className="form-control text-uppercase"
              placeholder="Enter IFSC Code"
              value={formData.ifscCode}
              onChange={handleChange}
              disabled={loading}
            />
            <label className="form-label">IFSC Code</label>
          </div>

          <div className="floating-form mb-3">
            <input
              type="number"
              name="amount"
              id="amount"
              className="form-control"
              placeholder="Enter Amount"
              value={formData.amount}
              onChange={handleChange}
              disabled={loading}
              min={10}
            />
            <label className="form-label" htmlFor="amount">
              Amount
            </label>
          </div>
          <div className="floating-form mb-3">
            <input
              type="number"
              name="mpin"
              id="mpin"
              className="form-control"
              placeholder="Enter MPIN"
              value={formData.mpin}
              onChange={handleChange}
              disabled={loading}
            />
            <label className="form-label" htmlFor="mpin">
              MPIN
            </label>
          </div>



          {/* Buttons */}
          <div className="d-flex justify-content-between mb-3">
            <Button type="submit" className="ellipsis" disabled={loading}>
              Pay Now
            </Button>
            <Button type="button" className="ellipsis" variant="warning">
              Cancel
            </Button>
          </div>
        </form>
      </div>
      {showOtpModal && (
        <div className="otp-backdrop">
          <div className="otp-modal">
            <h5 className="otp-title">Verify OTP</h5>
            <p className="otp-subtitle">
              Enter the OTP sent to your registered mobile
            </p>

            <input
              type="number"
              className="form-control otp-input"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              maxLength={6}
            />

            <div className="d-flex justify-content-between mt-4">
              <Button
                variant="warning"
                type="button"
                onClick={() => {
                  setShowOtpModal(false);
                  setOtp("");
                }}
              >
                Cancel
              </Button>

              <Button
                type="button"
                onClick={handleOtpSubmit}
                disabled={!otp || loading}
              >
                Verify & Pay
              </Button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default TransectionCardAirtel;
